import { Store } from "pullstate";

export const CurrentScan = new Store({
  content: "",
  loading: false,
});
